import type { MfaPendingInfo } from '@platform/api-client';
import { Alert, MfaLoginChallenge, MfaSecurityBody as SecurityBody } from '@platform/ui';
import { useI18n } from '@platform/i18n';
import { api } from './api';

export function MfaChallenge({ pending, onDone, onCancel }: { pending: MfaPendingInfo; onDone: () => void; onCancel: () => void }) {
  return <MfaLoginChallenge client={api.mfa} pending={pending} onDone={onDone} onCancel={onCancel} />;
}
export function MfaSecurityBody({ onChanged, enrollmentOnly }: { onChanged?: () => void; enrollmentOnly?: boolean }) {
  const { t } = useI18n();
  return api.mfa ? <SecurityBody client={api.mfa} onChanged={onChanged} enrollmentOnly={enrollmentOnly} /> : <Alert>{t('mfa.unavailable')}</Alert>;
}
